export default class Theme {
    constructor(options) {
        this.options = options;
    }

    setPrimaryColor() {
        // let dom = document.querySelector('body[theme-mode="light"]');
        // if (dom) {
        //     dom.style.setProperty('--primary-color', `red`);
        //     dom.style.setProperty('--default-color', `yellow`);
        // }
    }
}
